// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Text, Button } from '@gandi/ui';

import { RENEWABLE_LIMIT } from './modules';

export type Props = {
  renewableProductCount: number,
  onClick: (evt: SyntheticMouseEvent<>) => Promise<void>,
};

export function AddAllSuggestedRow({
  renewableProductCount,
  onClick,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base flex flexGrow1 flexJustifyBetween marginBottom="base">
      <Text size="bigger" weight="semibold">
        {renewableProductCount > RENEWABLE_LIMIT
          ? __('A lot of products are expiring, including')
          : __('You should also renew these products')}
      </Text>
      <Button onClick={onClick}>{__('Add all to cart')}</Button>
    </Base>
  );
}
